// forms
// route page
import { HttpClient } from '@angular/common/http';
import { IMyOptions } from 'ng-uikit-pro-standard';
import { LoginUser } from 'src/app/models/login-user';
import { UserService } from '../../../services/user.service';
import { ApiResponse } from 'src/app/models/api-response';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AppConfigService } from '../../../app-config.service.service';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CompanySettingsService } from 'src/app/services/company-settings.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { MapInformationService } from 'src/app/services/map-information.service';
@Component({
  selector: 'app-login',
  templateUrl: './login-usertemp.component.html',
  styleUrls: ['./login-usertemp.component.scss']
})

export class LoginUserTempComponent implements OnInit {
  @ViewChild('uploader', { static: true })
  uploader: any;
  optionCompanysSelect: Array<any>;
  cardForm: FormGroup;
  submitted = false;
  isLoading = false;
  msgError: string;
  showError = false;
  file: File | null;
  apiBaseUrl: string;
  showPassword = false;
  typeInputPassword = 'password';
  settings: string;

  dumLoginUser: LoginUser;

  constructor(private formBuilder: FormBuilder, private router: Router, private http: HttpClient,
    private userService: UserService, private appConfigService: AppConfigService, private activatedRoute: ActivatedRoute, 
    public settingsCompany: CompanySettingsService,
    public apiConfig: AppConfigService,
    private route: ActivatedRoute, public MapInformationService: MapInformationService, public toast: ToastService) {

    // this.route.queryParams.subscribe(params => {
    // });

    this.settings = localStorage.getItem('settings');

    if (!this.settings || this.settings == 'null')
      this.settings = null;
    // validations
    // this.cardForm = fb.group({
    //   materialFormCardNameEx: ['', Validators.required],
    //   materialFormCardEmailEx: ['', [Validators.email, Validators.required]],
    //   materialFormCardConfirmEx: ['', Validators.required],
    //   materialFormCardPasswordEx: ['', Validators.required]
    // });
  }

  // onFileAdd(file: any) {
  //   this.file = file;
  // }
  //
  // onFileRemove() {
  //   this.file = null;
  // }
  //
  // uploadFile() {
  //   if (this.file) {
  //     const data = new FormData();
  //     data.append('file', this.file, this.file.name);
  //     const url = 'http://localhost:3000/api/upload/';
  //
  //   }
  // }
  ngOnInit() {


    // var autoStart = localStorage.getItem('autoStart');

    // if (autoStart != undefined) {

    //   var tmpEmail = localStorage.getItem('email');

    //   this.userService.autoLoginUserTemp(tmpEmail).subscribe((data: ApiResponse) => {
    //     if (data.connected) {
    //       localStorage.clear();

    //       if (this.settings)

    //       localStorage.setItem('termaccepted', data.termAccepted.toString());
    //       localStorage.setItem('token', data.token);
    //       localStorage.setItem('userName', data.userName);
    //       localStorage.setItem('isTempUser', '1');
    //       localStorage.setItem('idTempUser', data['userTempID']);
    //       localStorage.setItem('email', tmpEmail);
    //       // localStorage.setItem('currentLat', data.lat);
    //       // localStorage.setItem('currentLong', data.long);
    //       // localStorage.setItem('ubicacion', data.ubicacion);
    //       this.userService.currentUserName.next(data.userName);
    //       this.userService.isClient.next(JSON.parse(data.isClient.toLocaleLowerCase()));

    //       // if (data.customerID) {
    //         // this.userService.Get_UserSettingsCE(data.customerID).subscribe(result => {
    //         //   console.log(result)

    //           // if (result.length > 0 && result[0].CLIENTUSERSETTING) {
    //           //   // let obj = JSON.parse(result[0].CLIENTUSERSETTING);
    //           //   // obj.regionid = result.RegionID;
    //           //   // localStorage.setItem('settings', JSON.stringify(obj));
                
    //           //   // localStorage.setItem('settings', result[0].CLIENTUSERSETTING);
    //           //   // localStorage.setItem('UserCompanyName', result[0].UserCompanyName);


    //           //   // This code detect boostrap screen standar resolution. Its used to start always
    //           //   // with home page if its mobile screen *************************
    //           //   const width = Math.max(
    //           //     document.documentElement.clientWidth,
    //           //     window.innerWidth || 0
    //           //   )
    //           //   var screenType = 'xl';
    //           //   if (width <= 576) { screenType = 'xs' }
    //           //   if (width <= 768) { screenType = 'sm' }
    //           //   if (width <= 992) { screenType = 'md' }
    //           //   if (width <= 1200) { screenType = 'lg' }
    //           //   var ignoreStartPage = false;
    //           //   if (screenType == 'xs' || screenType == 'sm') { ignoreStartPage = true }


    //           //   this.userService.settings.next(obj);


    //           //   let goto = obj.startPage && !ignoreStartPage ? obj.startPage : '/home';
    //           //   // this.router.navigateByUrl(goto);
    //           //   if (result[0].cubeWorksOnly == 1){
    //           //     this.router.navigateByUrl("/clientDashboard");
    //           //   } else {
    //           //     this.router.navigateByUrl(goto);
    //           //   }
    //           // } else {
    //             // if (result[0].cubeWorksOnly == 1){
    //             //   this.router.navigateByUrl("/clientDashboard");
    //             // } else {
    //             // }
    //             // }
    //             // }, err => {
    //               //   this.router.navigateByUrl('/home')
    //               // }
    //             // );
    //             this.router.navigateByUrl('/plans');
    //       // }
    //     } else {
    //       this.showError = true;
    //       this.msgError = 'Invalid username or password';
    //     }
    //   }, error => {
    //     this.showError = true;
    //     this.msgError = 'Server internal error, please contact the administrator!';
    //   });

    // }

    sessionStorage.clear();
    localStorage.clear();


    this.cardForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });

    this.apiBaseUrl = this.appConfigService.apiBaseUrl;


    this.optionCompanysSelect = [
      { value: '1', label: 'Amazing Control' },
      { value: '2', label: 'CUBE-USA' },
      { value: '3', label: 'South Florida Control' },
      { value: '4', label: 'Template Company' },
      { value: '5', label: 'Travis Brothers' },
    ];

  }

  public resolved(captchaResponse: string): void {
  }

  public onError(errorDetails): void {
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    this.typeInputPassword = this.showPassword ? 'text' : 'password';
  }
  onSubmit() {

    this.showError = false;
    this.msgError = '';
    this.submitted = true;
    // stop here if form is invalid
    if (this.cardForm.invalid) {
      return;
    }

    this.isLoading = true;
    let value = this.cardForm.value;

    let info = {
      method: 'Authenticate_TempUser',
      email: value.username,
      password: value.password
    }

    this.MapInformationService.MethodCallApiFlexUtility(info).subscribe((data: any) => {

      console.log('AQUIIIIIIIIIIIIIIIIIIIIII');

      if (data.length > 0 && data[0].ID != null) {

        if(data[0].ID != 0) {
          localStorage.clear();
  
          localStorage.setItem('email', info.email);
          localStorage.setItem('tempUser', JSON.stringify(data[0]));

          console.log('USER TEMPPPPP');
          console.log(JSON.stringify(data[0]));
  
          this.router.navigateByUrl("/plans");

        } else {
          // this.router.navigateByUrl("/plans");
          this.toast.warning('The user is not registered')
        }
        
      } else {
        this.showError = true;
        this.msgError = 'Invalid username or password';
      }
    }, error => {
      this.showError = true;
      this.msgError = 'Server internal error, please contact the administrator!';
    });
    this.submitted = false;
    this.isLoading = false;
  }
  gotoEstimate() {
  }
  public myDatePickerOptions: IMyOptions = {
  }

}
